/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scl_Note_Create_PxkInputs */

const vi_scl_note_create_pxk = /** @type {(inputs: Scl_Note_Create_PxkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tạo phiếu xuất`)
};

/**

* @param {Scl_Note_Create_PxkInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const scl_note_create_pxk = /** @type {((inputs?: Scl_Note_Create_PxkInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scl_Note_Create_PxkInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_scl_note_create_pxk(inputs)
});